<template>
  <div class="anonymity-query">
    <!-- 普通用户扫码 -->
    <template v-if="sourceType==1">
      <empty-box v-if="type === 3 && isRecord === false" style="margin-bottom:16px;">
        <span class="table-name">设备备案</span>

        <a-form-model ref="refForm" :model="recordForm" :rules="rules">
          <a-form-model-item label="用户单位：" prop="userCompany" :colon="false">
            <a-input v-model="recordForm.userCompany" placeholder="请输入" />
          </a-form-model-item>

          <a-form-model-item label="手机号：" prop="userPhone" :colon="false">
            <a-input v-model="recordForm.userPhone" placeholder="请输入" />
          </a-form-model-item>

          <a-form-model-item label="验证码：" prop="code" :colon="false">
            <div style="display:flex;margin:4px 0px;">
              <a-input v-model="recordForm.code" style="flex:1;" />
              <a-button
                :disabled="codeBtnDisabled"
                @click="clickGetCode"
                style="width:100px;margin-left:8px;"
              >{{codeBtnText}}</a-button>
            </div>
          </a-form-model-item>

          <a-form-model-item>
            <a-button type="primary" style="margin-left:88px" :loading="btnLoading" @click="onSubmit">提交</a-button>
          </a-form-model-item>
        </a-form-model>
      </empty-box>

      <empty-box v-if="type === 3 && isRecord === true" style="margin-bottom:16px;">
        <span class="table-name">设备备案(已备案)</span>
        <a-button type="primary" @click="isRecord = false">重新备案</a-button> 
      </empty-box>
    </template>
   
    <!-- 生产人员扫码 -->
    <empty-box v-if="type === 2 && sourceType==1" style="margin-bottom:16px;">
      <span class="table-name">保修期更改</span>

      <a-form-model ref="refForm" :model="repairForm" :rules="repairRules">
        <a-form-model-item label="保修期：" prop="warrantyPeriod" :colon="false">
          <a-select v-model="repairForm.warrantyPeriod">
            <a-select-option :value="1">一年半</a-select-option>
            <a-select-option :value="2">两年</a-select-option>
            <a-select-option :value="3">两年半</a-select-option>
            <a-select-option :value="4">三年</a-select-option>
            <a-select-option :value="5">四年</a-select-option>
            <a-select-option :value="6">五年</a-select-option>
          </a-select>
        </a-form-model-item>

        <a-form-model-item class="isUpdate" label="是否更新出厂日期：" prop="isUpdate" :colon="false">
          <a-checkbox v-model="repairForm.isUpdate"></a-checkbox>
        </a-form-model-item>

        <a-form-model-item>
          <a-button type="primary" style="margin-left:88px" :loading="btnLoading" @click="onSubmit">提交</a-button>
        </a-form-model-item>
      </a-form-model>
    </empty-box>
    <my-list :dataSource="dataSource" :loading="loading" :btnConfig="sourceType==1 ? ['查看文件','查看证书']: ['查看文件']"></my-list>
  </div>
</template>
<script>
import {
  queryDeviceBySerialNumber,
  recordDevice,
  getPhoneCode,
  getOpenid,
  setWarrantyPeriod
} from '../api/api'
import request from '../utils/request'

const rules = {
  userCompany: [
    {
      required: true,
      message: '请输入',
      trigger: 'blur'
    },
    {
      max: 64,
      message: '最大64个字符',
      trigger: 'blur'
    }
  ],
  userPhone: [
    {
      required: true,
      message: '请输入',
      trigger: 'blur'
    },
    {
      pattern: /^1[3456789]\d{9}$/,
      message: '手机号格式错误',
      trigger: 'blur'
    }
  ],
  code: [
    {
      required: true,
      message: '请输入',
      trigger: 'blur'
    },
    {
      max: 6,
      message: '最大6个字符',
      trigger: 'blur'
    }
  ]
}

const repairRules = {
  warrantyPeriod: [
    {
      required: true,
      message: '请选择'
    }
  ]
}

export default {
  name: 'anonymity-query',

  data() {
    return {
      loading: false,
      btnLoading: false,
      dataSource: [],

      recordForm: {
        userCompany: undefined,
        userPhone: undefined,
        code: undefined
      },

      repairForm: {
        warrantyPeriod: 1,
        isUpdate: false
      },

      rules,
      repairRules,

      codeBtnText: '获取验证码',
      codeBtnDisabled: false,
      interval: null,

      openid: undefined,
      type: undefined, //分组（1：销售 2：生产）  普通用户可以备案  生产可以更改保修期  销售只能看
      isRecord: false,
      sourceType: 1,
    }
  },

  computed: {
    serialNumber() {
      return this.$route.params.serialNumber
    }
  },

  created() {
    this.isAttention()
  },

  beforeDestroy() {
    clearInterval(this.interval)
  },

  methods: {
    fetchData() {
      this.loading = true
      queryDeviceBySerialNumber(this.serialNumber)
        .then(res => {
          if (res.error.code === 0) {
            this.dataSource = [res.response]

            if (res.response.recordTime) {
              this.isRecord = true
            } else {
              this.isRecord = false
            }
            // 加了字段source，数据源（1：公司内部 2：传声器接口上传）
            this.sourceType = res.response.source || 1
            getOpenid(this.openid).then(res => {
              if (res.error.code === 0) {
                if (res.response) {
                  this.type = res.response.type
                } else {
                  this.type = 3
                }
              }
            })
            // this.type = 3
          } else {
            this.dataSource = []
          }
        })
        .finally(() => {
          this.loading = false
        })
    },

    //是否关注公众号
    async isAttention() {
      const code = window.location.href.split('code=')[1].split('&')[0]
      const res = await request({
        url: `/oa/getUserInfo?code=${code}`,
        method: 'get'
      })

      if (res.errcode) {
        this.$message.error(res.errmsg)
      } else {
        if (res.subscribe === 1) {
          this.fetchData()
          this.openid = res.openid
        } else {
          window.location.href = 'https://www.aihua-ai.cn:8088'
        }
      }
    },

    //点击提交
    onSubmit() {
      this.$refs.refForm.validate(valid => {
        if (valid) {
          this.btnLoading = true

          if (this.type !== 1 && this.type !== 2) {
            let param = { ...this.recordForm }
            param.serialNumber = this.serialNumber
            recordDevice(param)
              .then(res => {
                if (res.error.code === 0) {
                  this.$message.success('备案成功')
                  this.fetchData()
                }
              })
              .finally(() => {
                setTimeout(() => {
                  this.btnLoading = false
                }, 500)
              })
          }

          if (this.type === 2) {
            let param = { ...this.repairForm }
            param.serialNumber = this.serialNumber
            param.openId = this.openid
            setWarrantyPeriod(param)
              .then(res => {
                if (res.error.code === 0) {
                  this.$message.success('更改成功')
                  this.fetchData()
                }
              })
              .finally(() => {
                setTimeout(() => {
                  this.btnLoading = false
                }, 500)
              })
          }
        }
      })
    },

    clickGetCode() {
      this.$refs.refForm.validateField(['userPhone'], errorMessage => {
        if (errorMessage === '') {
          getPhoneCode(this.recordForm.userPhone).then(res => {
            if (res.error.code === 0) {
              this.$message.success('验证码发送成功')
            }
          })

          this.codeBtnDisabled = true
          this.codeBtnText = 59
          this.interval = setInterval(() => {
            this.codeBtnText--
            if (this.codeBtnText <= -1) {
              clearInterval(this.interval)
              this.codeBtnDisabled = false
              this.codeBtnText = '获取验证码'
            }
          }, 1000)
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.anonymity-query {
  width: 100%;
  margin: 0 auto;
  // padding: 8px;
  /deep/ .empty-box {
    margin: 0px;
  }
  /deep/ .ant-form-item {
    display: flex;
    .ant-form-item-label {
      width: 88px;
      margin-top: 10px;
      padding: 0;
    }
    .ant-form-item-control-wrapper {
      flex: 1;
    }
  }
}

/deep/ .isUpdate {
  .ant-form-item-label {
    width: 138px !important;
  }
}

.table-name {
  display: block;
  margin-bottom: 16px;
  color: rgba(0, 0, 0, 0.85);
  font-weight: bold;
  font-size: 16px;
  line-height: 1.5;
}
</style>